import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'nx-card-content',
  templateUrl: './nx-card-content.component.html',
  styleUrls: ['./nx-card-content.component.scss']
})
export class NxCardContentComponent implements OnInit {
  @Input() data: any;
  @Input() border: boolean;
  @Input() layout: number;
  @Input() content: string;
  @Input() config: any;

  constructor() { }
 
  ngOnInit() :void {
  }

}
